import { render, staticRenderFns } from "./HotkeyDrawer.vue?vue&type=template&id=f21b7410&scoped=true&"
import script from "./HotkeyDrawer.vue?vue&type=script&lang=ts&"
export * from "./HotkeyDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./HotkeyDrawer.vue?vue&type=style&index=0&id=f21b7410&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f21b7410",
  null
  
)

export default component.exports